import React from 'react';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import styled from 'styled-components';
import { isNumber } from 'lodash';

import iowaRG from '../../assets/iowa.png';
import ageImg from '../../assets/rg-us-age.png';
import appConfig from '../../appConfig';
import PortalSessionContext from '../../contexts/PortalSessionContext/PortalSessionContext';
import useServerTime from '../../hooks/useServerTime';
import USstateConfig from '../../Account/constants/USstateConfig';

dayjs.extend(duration);

const USFooterNotes: React.FC = () => {
	const [sessionDurationDisplay, setSessionDurationDisplay] = React.useState<string | null>(null);
	const { user, sessionTime } = React.useContext(PortalSessionContext);
	const serverTimeDisplay = useServerTime();

	const isLoggedIn = !!user?.id;

	React.useEffect(() => {
		if (!isLoggedIn) return;
		let durationCounter = isNumber(sessionTime) ? sessionTime : 0; // fallback to 0

		const intervalRef = setInterval(() => {
			setSessionDurationDisplay(dayjs.duration(++durationCounter, 'seconds').format('HH:mm:ss'));
		}, 1000);

		return () => {
			clearInterval(intervalRef);
			setSessionDurationDisplay(null);
		};
	}, [isLoggedIn, sessionTime]);

	return (
		<USFooterNotesWrapper>
			<div>
				{appConfig.regions.usState === 'OH' && (
					<>
						<p>
							You are welcome to register from any state in the US., but must be 21+ years old and physically located in
							the state of Ohio to wager. Gambling problem? Call{' '}
							<a href={`tel:${USstateConfig.gamblingPhone}`} title="Call Gambling Help">
								{USstateConfig.gamblingPhoneDisplay}
							</a>
							.
						</p>
						<p>
							PlayUp is regulated by the Ohio Casino Control Commission as a sportsbook operator in accordance with OH
							HB 29 law (wagering statute) and the regulations promulgated thereunder.
						</p>
					</>
				)}
				{appConfig.regions.usState === 'IA' && (
					<>
						<p>
							If you or someone you know has a gambling problem and wants help, call{' '}
							<a href={`tel:${USstateConfig.gamblingPhone}`} title="Call Gambling Help">
								{USstateConfig.gamblingPhoneDisplay}
							</a>
							.
						</p>
						<p>
							PlayUp Interactive IA Inc. is licensed by the Iowa Racing and Gaming Commission to provide online sports
							wagering services for use by registered users in Iowa in partnership with Horseshoe Council Bluffs Casino
						</p>
					</>
				)}
				<p>
					&copy; {new Date().getFullYear()} Playup Interactive {appConfig.regions.usState} Inc. | Stay in control. Leave
					before you lose it. Gamble Responsibly
				</p>
				<p>
					{serverTimeDisplay && `Server Time: ${serverTimeDisplay}`}
					{sessionDurationDisplay && ` | Session Time: ${sessionDurationDisplay} `} | Version{' '}
					{appConfig.portal.appVersion}{' '}
					{user?.last_login_at && `Last login: ${dayjs(user?.last_login_at).format('DD/MM/YYYY hh:mm A')}`}
				</p>
			</div>
			<div>
				{appConfig.regions.usState === 'IA' && (
					<>
						<img src={ageImg} alt="Gamble responsibly" />
						<a href={'https://www.iowagaming.org/responsible-gaming/'} target="_blank" rel="noreferrer">
							<img src={iowaRG} alt="Gamble responsibly" />
						</a>
					</>
				)}
			</div>
		</USFooterNotesWrapper>
	);
};

export default USFooterNotes;

const USFooterNotesWrapper = styled.div`
	display: flex;
	padding-bottom: 50px;

	div:last-child {
		display: flex;
		flex-shrink: 0;
		padding: 0 0.5rem;
		align-content: center;
		align-items: center;

		@media (min-width: 768px) {
			padding: 0 1.5rem;
		}

		svg {
			width: 58px;
			height: 58px;
		}
		img {
			width: 58px;
			height: 58px;
			margin-right: 0.5rem;
		}
	}

	div:first-child {
		flex-grow: 1;
		flex-wrap: wrap;
		flex-basis: 100%;
	}

	p {
		font-size: 0.75rem;
		margin-bottom: 0.5rem;
		line-height: 1.3;
	}
`;
